import request from '../utils/request';

export default {
  // 获取微信网页授权URL
  getAuthUrl(params) {
    return request.get('/open/OAuth2Url', params);
  },

  // 根据code获取微信用户信息
  getWxUserInfo(params) {
    return request.get('/open/wxUserInfo', params);
  },

  // 微信openid登录
  weChatLogin(data) {
    return request.post('/auth/login', {
      terminalType: '4',
      channelType: '5',
      userType: '2',
      userName: data,
    });
  },

  // 刷新Access Token
  refreshToken(refreshToken) {
    return request.post('/auth/refresh', {
      refreshToken,
    });
  },

  // 获取微信jssdk配置参数
  jssdk(params) {
    return request.get('/open/jssdk', params);
  },

  weChatBinding(data) {
    return request.post('/open/binding', data);
  },

  weChatUntying(data) {
    return request.delete('/khmk/binding', data);
  },

  sendVaildCodePhoneByBinding(phone) {
    return request.get(`/open/sms/bind/phone/${phone}`);
  },

  sendVaildCodePhone(phone) {
    return request.get(`/open/sms/phone/${phone}`);
  },

  sendVaildCodeEmail(params) {
    return request.get('/open/sms/email', params);
  },

  loadingUserInfo() {
    return request.get('/khmk/kh/me');
  },
  querykhxx() {
    return request.post('/khmk/kh/cxkhxx');
  },
};



// WEBPACK FOOTER //
// ./src/api/login.api.js